// Event type can be any string for now, later it might an enum
export type AnalyticsEventType = string;

export interface AnalyticsConfig {
  postHogApiKey: string;
  postHogHost?: string;
  enabled: boolean;
  debug?: boolean;
}

export const ANALYTICS_CONFIG = 'ANALYTICS_CONFIG';
